import React, {useLayoutEffect} from 'react'

import Workspace from "../../../../core/model2/space/workspaces/workspace"
import NavigationMenuItem from "../menu-item"
import {useForceUpdate} from "../../../../core/gd/utils/dom-and-react/react-utils"
import {ViewType} from "../../../../core/gd/const/views/view-type"

type Props = {
    workspace: Workspace
}

// const debug = "NavigationMenuItemEverything"
const debug = false

export default function NavigationMenuItemEverything(props: Props) {

    const forceUpdate = useForceUpdate()

    useLayoutEffect(() => {
        gd.router.on('route', onRoute)

        return ()=> {
            gd.router.off('route', onRoute)
        }
    }, [])

    const onRoute = () => {
        setTimeout(()=>{
            forceUpdate()
        }, 0)
    }

    const currentRouteFragment = gd.router.history.fragment || ''
    const urlSections = currentRouteFragment.split('/')

    let isSelected = false
    // if url stars from 'p'
    if (urlSections[0] === 'p') {
        const project = gd.session.projects.get(urlSections[1])
        // if project is current workspace project and current view is not "No views"
        if (
            project?.id === props.workspace.project.id
            && gd.projectViews?.currentView?.type !== ViewType.PROJECT_NO_VIEWS
        ) {
            isSelected = true
        }
    }

    debug && console.log(debug, 'render', isSelected, urlSections, gd.projectViews?.currentView)

    return (
        <NavigationMenuItem
            name        = "Everything"
            selected    = {isSelected}
            icon        = "i5-structure-1"
            url         = {'p/{0}/everything'.f(props.workspace.project.id)}
        />
    )
}

